// Avatar circular con initials. Sin imagen — los mockups usan initials puras.
//
//   <Avatar initials="JM" />
//   <Avatar initials="DC" size={32} />

import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '../../lib/utils';

interface AvatarProps extends HTMLAttributes<HTMLDivElement> {
  initials: string;
  /** Px (default 28). */
  size?: number;
}

export const Avatar = forwardRef<HTMLDivElement, AvatarProps>(function Avatar(
  { initials, size = 28, className, ...props },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn(
        'inline-flex flex-shrink-0 items-center justify-center rounded-full',
        'bg-surface-overlay text-fg-secondary border border-border',
        'font-medium tracking-wider',
        className,
      )}
      style={{
        width: size,
        height: size,
        fontSize: Math.max(10, Math.floor(size * 0.42)),
      }}
      aria-label={initials}
      {...props}
    >
      {initials.toUpperCase()}
    </div>
  );
});
